import { render, staticRenderFns } from "./selectSupplierBoxDialog.vue?vue&type=template&id=1a115723"
import script from "./selectSupplierBoxDialog.vue?vue&type=script&lang=js"
export * from "./selectSupplierBoxDialog.vue?vue&type=script&lang=js"
import style0 from "./selectSupplierBoxDialog.vue?vue&type=style&index=0&id=1a115723&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports